import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel } from './components/MetaPixel';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Language + translation blocking (Spanish - Latin America)
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'MEGAPACK Funcional 365 — Todo tu año de funcional, listo';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'MEGAPACK Funcional 365: 6 Tomos, 365 sesiones, 5 bonos estratégicos. Todo tu año de clases de funcional, listo desde hoy.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // Performance: preconnect to the CDN serving the hero mockup
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: 'https://cdn.magicpatterns.com/uploads/gQtkVod4u9DhJDMUTT1MKv/mockup_sticker.png',
      // @ts-ignore
      fetchpriority: 'high'
    });
    // Performance: warm up the checkout connection so CTA clicks navigate
    // instantly. TCP + TLS happens in the background while the user reads.
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://funcional-365.impultienda.ar'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://funcional-365.impultienda.ar'
    });
    // Performance: resolve the pixel host early without blocking the paint
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://connect.facebook.net'
    });
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandOrange selection:text-white notranslate" data-id="element-0" data-mp="1w0zks2rvy4ak">
      <MetaPixel data-id="element-1" data-mp="1m792jfmcqq3b" />
      <SocialProofPopup data-id="element-2" data-mp="6ofdgmsxjree" />
      <ExitIntentModal data-id="element-3" data-mp="6nw6g14tinf5" />
      <Hero data-id="element-4" data-mp="6nmfobby8c8e" />
      <SocialProof data-id="element-5" data-mp="6muln4y02mk8" />
      <Testimonials1 data-id="element-6" data-mp="6qs55rohpg4n" />
      <Problem data-id="element-7" data-mp="apr856qnv2tg" />
      <ProductTomos data-id="element-8" data-mp="aq9b0m7twfac" />
      <Bonuses data-id="element-9" data-mp="aqsh95o49f8j" />
      <UrgencyCounter data-id="element-10" data-mp="arc14rxbudp7" />
      <Pricing data-id="element-11" data-mp="ano9jybg01d4" />
      <Testimonials2 data-id="element-12" data-mp="qwvr4d1d8l5u" />
      <Guarantee data-id="element-13" data-mp="qy74n4km57a5" />
      <FAQ data-id="element-14" data-mp="qyqb9p4tc98v" />
      <CostOfNotHaving data-id="element-15" data-mp="qygla1jrq236" />
      <FinalCTA data-id="element-16" data-mp="m6fbqndzipgu" />
      <Footer data-id="element-17" data-mp="m6ozs5fgymjw" />
    </div>;
}